import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AccountFormatService } from '../../../services/account-format.service';
import { DataClientService } from '../../../services/data-client.service';
import { EnumService } from '../../../services/enum.service';
import { LoadingService } from '../../../services/loading.service';
import { SessionService } from '../../../services/session.service';
import { OnboardingProductsStore } from '../../../store/store';
import { environment } from '../../../../environments/environment';
import {
  CheckTokenActions,
  ClientExternalChallengeActions,
  CustomerChallengeGenerateActions,
  CreateProductActions,
  UiActions,
  TreActions,
  CreateUserAccountActions
} from '../../../store/actions';
import { ApiResponseStatus, StepsClientTypes } from '../../../shared/enums';
import {
  RequestCheckToken,
  RequestClientExternalChallenge,
  RequestCreateProduct,
  RequestCreateUserAccount,
  RequestCustomerChallengeGenerate,
  RequestTre
} from '../../../shared/interfaces';
import { DatadogService } from '../../../services/datadog/datadog.service';
import { TagPage } from '../../../store/actions/ui.actions';

@Component({
	selector: 'lib-client-step-softoken-vu',
	templateUrl: './client-step-softoken-vu.component.html',
	styleUrls: ['./client-step-softoken-vu.component.scss']
})
export class ClientStepSoftokenVuComponent implements OnInit, OnDestroy {
  public factorSecond: boolean;
  public loading: boolean;
  public fragment: any;
  tokenIncorrect: boolean;
  isJointTurn: boolean;
  timeLeft = 60;
  interval: any;
  authProvider: string;
  isSent = false;
  customerChallengeGenerateCreation$ = this.store.pipe(select(OnboardingProductsStore.selectors.customerChallengeGenerate));
  checkTokenCreation$ = this.store.pipe(select(OnboardingProductsStore.selectors.checkToken));
  createUserAccountSuscription$ = this.store.pipe(select(OnboardingProductsStore.selectors.createUserAccount));
  createProductSubscription$ = this.store.pipe(select(OnboardingProductsStore.selectors.createProduct));
  treSubscription$ = this.store.pipe(select(OnboardingProductsStore.selectors.tre));

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private sessionService: SessionService,
    private dataClientService: DataClientService,
    private dataDogService: DatadogService,
    private enumService: EnumService,
    public loadingService: LoadingService,
    public accountFormatService: AccountFormatService
  ) {}
  customerChallengeGenerateSuscription = this.customerChallengeGenerateCreation$.subscribe(({ response, error }) => {
    if (error !== null) {
      this.actionCleanStateAndRedirect(CustomerChallengeGenerateActions);
    }
    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.store.dispatch(CustomerChallengeGenerateActions.cleanState());
      }
    }
	});

  checkTokenSuscription = this.checkTokenCreation$.subscribe(({ response, error }) => {
    // error case
    if (error !== null) {
      this.actionCleanStateAndRedirect(CheckTokenActions);
    }

    // token error
    if (response) {
      if (response.code === ApiResponseStatus.FAIL) {
        this.tokenIncorrect = true;
        this.isSent = false;
        this.pauseTimer();
        return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      } else if (response.code === ApiResponseStatus.OK) {
        this.store.dispatch(CheckTokenActions.cleanState());
        this.tokenIncorrect = false;
        this.callTre();
      } else {
        return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
      }
    }
	});

  createProductSubscription = this.createProductSubscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
      }

    if (error != null) {
      this.dataDogService.addCustomError(error, 'Account create error', environment.mode, { channel: 'client' });
      this.actionCleanStateAndRedirect(CreateProductActions);
    }
    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Account created', environment.mode, { channel: 'client' });
        this.dataClientService.setAccountNumber(response.client.data.identificadorProducto);
        this.dataClientService.setCCI(response.client.data.CCI);
        this.store.dispatch(CreateProductActions.cleanState());
        return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_CONFIG_4_MOBILE }));
      } else {
        this.store.dispatch(CreateProductActions.cleanState());
        return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR}));
      }
    }
	});

  createUserAccountSuscription = this.createUserAccountSuscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'Client create error', environment.mode, { channel: 'client' });
      this.actionCleanStateAndRedirect(CreateUserAccountActions);
    }
    if (response) {
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Client created', environment.mode, { channel: 'client' });
        this.store.dispatch(CreateUserAccountActions.cleanState());
        this.callCreateProduct();
      } else {
        this.actionCleanStateAndRedirect(CreateUserAccountActions);
      }
    }
  });

  treSubscription = this.treSubscription$.subscribe(({ response, error }) => {
    if (!response) {
      return;
    }

    if (error !== null) {
      this.dataDogService.addCustomError(error, 'ABR4 authentication error', environment.mode, { channel: 'client' });
      this.actionCleanStateAndRedirect(TreActions);
    }
    if (response) {
      this.store.dispatch(TreActions.cleanState());
      if (response.client.operationState.code === ApiResponseStatus.OK) {
        this.dataDogService.addCustomEvent('Authenticated ABR4', environment.mode, { channel: 'client' });
        this.callCreateUserAccount();
      } else if (response.client.operationState.code === ApiResponseStatus.FAIL) {
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_NO_OFFER }));
      }
    }
	});

  ngOnInit() {
    document.getElementById('white-container').style.display = 'block';
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 10);
    this.setService();
    this.validatePlatform();
  }

  setService() {
    const googleAnalytics = {
      is_joint_account: this.dataClientService.isIsJointAccount(),
      job_information: {
        workActivityType: this.dataClientService.getWorkActivityType() ? this.dataClientService.getWorkActivityType() : 'No informado',
        dateEntryWork: this.dataClientService.getDateEntryWork() ? this.dataClientService.getDateEntryWork() : 'No informado',
        companyName: this.dataClientService.getCompanyName() ? this.dataClientService.getCompanyName() : 'No informado',
        rucCompany: this.dataClientService.getRucCompany() ? this.dataClientService.getRucCompany() : 'No informado',
        profession: this.dataClientService.getProfession() ? this.dataClientService.getProfession() : 'No informado'
      },
      currency_account_type: this.dataClientService.getCurrencyType()
    };
    this.store.dispatch(TagPage({text: 'soft-token-VU', extras: googleAnalytics}));
  }

  getCustomerChallengeGenerate() {
		const request: RequestCustomerChallengeGenerate = {
			deviceType: 'OTP'
		};
		this.store.dispatch(CustomerChallengeGenerateActions.getCustomerChallengeGenerate({ request }));
	}

  callClientExternalChallenge() {
		this.loadingService.loading = true;
		const request: RequestClientExternalChallenge = {};
		this.store.dispatch(ClientExternalChallengeActions.getClientExternalChallenge({ request }));
	}

  callCreateProduct() {
    const request: RequestCreateProduct = {
      client: {
        provider: 'SoftToken',
        tipoCuentaDescripcion: this.accountFormatService.getDescription()
      }
    };
    this.store.dispatch(CreateProductActions.getCreateProduct({ request }));
	}

  callCreateUserAccount() {
    const request: RequestCreateUserAccount = {};
    this.store.dispatch(CreateUserAccountActions.getCreateUserAccount({ request }));
  }

  callTre() {
    const request: RequestTre = {};
    this.store.dispatch(TreActions.getTre({ request }));
	}

  // Metodo para limpiar el estado luego de un error de servicio.
  actionCleanStateAndRedirect(action) {
    this.store.dispatch(action.cleanState());
    return this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_SERVICE_ERROR }));
  }

  resolveType(type) {
		let operationType;
		switch (type) {
			case 'Ahorro':
				operationType = 'a';
				break;
			case 'CTS':
				operationType = 'c';
				break;
			case 'Flex':
				operationType = 'c';
				break;
		}
		return operationType;
	}

  pauseTimer() {
		clearInterval(this.interval);
	}

  continue(idTransaction) {
    this.tokenIncorrect = false;
    const request: RequestCheckToken = { token: idTransaction };
    this.store.dispatch(CheckTokenActions.getCheckToken({ request }));
    this.loadingService.loading = true;
	}

  ngOnDestroy() {
		this.createProductSubscription.unsubscribe();
	}

  validatePlatform() {
		const platform = window.navigator.platform;
		let script = 'FastTrackBridge.requestOTP();';
		const drawScript = this.sessionService.drawScript;

		if (platform === 'iPhone' || platform === 'iPad') {
					script = "window.webkit.messageHandlers.RequestOTP.postMessage('');";
		}

		const fragment = document.createRange().createContextualFragment(`<script>$(document).ready(function() { ${script} });</script>`);
		this.appendBodyScript(fragment);
		if (drawScript === null) {
			this.fragment = document.createRange().createContextualFragment(
							"<script>function responseOTP(otp){ var event = new CustomEvent('responseOTP', {detail: {otp: otp}}); window.dispatchEvent(event);} function cancelSoftToken(){ var event = new CustomEvent('cancelSoftToken', {}); window.dispatchEvent(event);}</script>"
			);
			this.sessionService.setDrawScript('0');
			this.appendBodyScript(this.fragment);
		}
	}

  appendBodyScript = (fragment) => {
		document.body.appendChild(fragment);
	};

  @HostListener('window:responseOTP', ['$event.detail'])
  responseSoftoken(detail) {
		this.continue(detail.otp);
	}

	@HostListener('window:cancelSoftToken', [])
  cancelSoftToken() {
		this.checkTokenSuscription.unsubscribe();
		this.treSubscription.unsubscribe();
		this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_TERMS_CONDITIONS }));
		this.loadingService.loading = false;
	}
}
